import { TYPES_INBOX } from 'store/modules/user';
import { useInboxesStore } from 'store/modules';

export default (inbox_id) => {
    const inboxesStore = useInboxesStore();

    const inbox = inboxesStore.inboxes[inbox_id];
    const inboxGroup = inboxesStore.inboxesGroups[inbox_id];

    if (!inbox_id) return TYPES_INBOX.UNIFIED;
    if (inbox) return inbox.inboxType;

    return inboxGroup.inboxType;
};
